import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div data-testid="page-about">
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 sm:pt-28 pb-12">
        <div className="eyebrow text-[var(--pine)] mb-5">About us</div>
        <h1 className="font-display text-5xl sm:text-7xl leading-[0.95] max-w-3xl">
          We run<br/>
          <span className="text-[var(--clay)]">the only booking you need in Riga.</span>
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-12 gap-12 py-12">
        <div className="md:col-span-7 space-y-6 text-lg leading-relaxed text-[var(--ink)]">
          <p>
            Riga Party Weekend is a small Riga-based booking platform. We run a handful of our own tours,
            and for everything else we hand-pick the best independent operators in and around Riga,
            vet them in person, and bring them all together in one easy place to book.
          </p>
          <p>
            That means the floating sauna is a wood-fired pirts with a cold dip straight into the Daugava, not a hotel steam room.
            The kayaking is self-guided with the actual maps the locals use. The panorama cruise has a real bar on deck.
            Whether we're running it or one of our partners is, we make sure you end up with the right one — and that everything runs smoothly.
          </p>
          <p>
            We work with travellers visiting Riga from the UK and the Nordic countries in particular — short trips, long weekends, the occasional wedding party — but anyone is welcome.
          </p>
        </div>

        <div className="md:col-span-5">
          <div className="border border-[var(--border)] p-8 bg-[var(--bg-2)]">
            <div className="eyebrow text-[var(--pine)] mb-4">In numbers</div>
            <ul className="space-y-6">
              <Stat label="Tours we curate" value="6+" />
              <Stat label="Years in Riga" value="4" />
              <Stat label="Max group size" value="200+" />
              <Stat label="Average group" value="4–12" />
            </ul>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24 border-t border-[var(--border)] mt-12 flex flex-wrap items-center justify-between gap-6">
        <h2 className="font-display text-3xl sm:text-4xl max-w-xl leading-tight">
          Ready to put something on the calendar?
        </h2>
        <Link to="/contact" className="btn-primary" data-testid="about-cta-contact">
          Start an inquiry <ArrowRight size={16} />
        </Link>
      </section>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <li className="flex items-baseline justify-between">
      <span className="text-[var(--ink-soft)] text-sm">{label}</span>
      <span className="font-display text-3xl">{value}</span>
    </li>
  );
}
